export default function extractAddressComponents(place: google.maps.places.AddressComponent[]) {
  let streetAddress = '';
  let city = '';
  let postalCode = '';
  let province = '';
  let country = '';

  place.forEach((component) => {
    const types = component.types;

    if (types.includes('street_number')) {
      streetAddress += `${component.shortText} `;
    }

    if (types.includes('route')) {
      streetAddress += `${component.longText}`;
    }

    if (component.types.includes('locality')) {
      city += component.shortText;
    }

    if (component.types.includes('postal_code')) {
      postalCode += component.shortText;
    }

    if (component.types.includes('administrative_area_level_1')) {
      province += component.shortText;
    }

    if (component.types.includes('country')) {
      country += component.longText;
    }
  });

  return { streetAddress, city, postalCode, province, country };
}
